import React from "react";

interface IconProps {
  color: string;
}

const TechStackIcon: React.FC<IconProps> = ({ color }) => (
  <svg
    width="40"
    height="46"
    viewBox="0 0 50 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 35.7324L25 47.6924L48 35.7324M2 24.6924L25 36.6524L48 24.6924M25 1.69238L2 13.6524L25 25.6124L48 13.6524L25 1.69238Z"
      stroke={color}
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface TechStackBlockProps {
  title: string;
  icons: React.ReactNode[];
  opacity: number;
  titleColor?: string;
}

interface PortfolioTechStackProps {
  primaryColor?: string;
  blocks: TechStackBlockProps[];
}

const PortfolioTechStack: React.FC<PortfolioTechStackProps> = ({
  primaryColor = "#2c2d2c",
  blocks,
}) => {
  return (
    <div id="tech-stack" className="py-6 md:py-12 w-full xl:w-[95%]">
      <div className="flex gap-4 border-b border-gray-400 items-center py-2 pl-2 md:pl-8">
        <TechStackIcon color={primaryColor} />
        <h3 className="text-[2rem] md:text-[3rem]">TECH STACK</h3>
      </div>

      {/* Render titles separately above the blocks */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-4 px-12 py-8">
        {blocks.map((block, index) => {
          const rgbaColor =
            primaryColor
              .replace("#", "")
              .match(/.{1,2}/g)
              ?.map((hex) => parseInt(hex, 16))
              ?.join(",") || "44,45,44";

          return (
            <div key={index} className="flex flex-col w-full">
              {/* Move the title outside of the primary color block */}
              <h4
                className="text-[20px] text-center mb-2"
                style={{ color: block.titleColor || "#2C2D2C" }}
              >
                {block.title}
              </h4>

              {/* Block content with icons */}
              <div
                className="flex flex-col flex-grow justify-center px-[35px] py-[35px] items-center gap-[35px] rounded-[15px]"
                style={{
                  backgroundColor: `rgba(${rgbaColor}, ${block.opacity / 100})`,
                }}
              >
                <div className="flex items-center flex-col gap-8">
                  {block.icons.map((icon, index) => (
                    <div key={index}>{icon}</div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PortfolioTechStack;
